import styled from "@emotion/styled";
import { MDSText, MDSTextVariant, MDSTextColor } from "@/mds";
import type { FC } from "react";

interface ImportEmptyStateProps {
  /** Total number of notes available for import (before filtering) */
  totalNotesCount: number;
}

export const ImportEmptyState: FC<ImportEmptyStateProps> = ({ totalNotesCount }) => {
  const message =
    totalNotesCount > 0 ? "No notes match your search" : "No notes available for import.";

  return (
    <StyledEmptyState data-test-id="import-empty-state">
      <MDSText variant={MDSTextVariant.ParagraphS} color={MDSTextColor.Secondary}>
        {message}
      </MDSText>
    </StyledEmptyState>
  );
};

const StyledEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 388px;
  width: 100%;
`;
